/**
 * Handle references page javascript behavior
 */

window.app = window.app || {};

(function (referencesManager, $) {

    /**
     * infinite-scroll-menu selector
     * @type {string}
     * @private
     */
    var _infiniteMenu = "ul.infinite-scroll-menu";

    /**
     * menu item selector
     * @type {string}
     * @private
     */
    var _menuItem = _infiniteMenu + " .menu-item";

    /**
     * Featured class
     * @type {string}
     * @private
     */
    var _featured = ".featured";

    /**
     * pagination and logo sections
     * @type {string}
     * @private
     */
    var _paginationFixed = ".pagination-and-logo";

    /**
     * init var for bxslider vertical
     * @type {null}
     * @private
     */
    var _sliderNav = false;

    /**
     * Useful to deactivate infinite loop in slider config
     * @type {boolean}
     */
    var _infiniteLoop = true;

    /**
     * bx custom controls: "prev" class
     * @type {string}
     * @private
     */
    var _bxPrevSelector = ".custom-bx-controls .slider-prev";

    /**
     * bx custom controls: "next" class
     * @type {string}
     * @private
     */
    var _bxNextSelector = ".custom-bx-controls .slider-next";

    /**
     * BXSlider configuration
     * @type {{
     *     mode: string,
     *     pager: boolean,
     *     controls: boolean,
     *     autoStart: boolean,
     *     infiniteLoop: boolean,
     *     slideSelector: string,
     *     minSlides: number,
     *     moveSlides: number,
     *     adaptiveHeight: boolean,
     *     auto: boolean
     * }}
     */
    var sliderConfig = {
        mode:               'vertical',
        pager:              false,
        controls:           false,
        autoStart:          false,
        infiniteLoop:       _infiniteLoop,
        slideSelector:      "li.menu-item",
        minSlides:          8,
        moveSlides:         1,
        adaptiveHeight:     true,
        auto:               true
    };

    /**
     * Full screen slider selector
     * @type {string}
     */
    var sliderFullScreen = "#slider-fullscreen";

    /**
     * Sections of full screen slider
     * @type {string}
     */
    var fullScreenSections = sliderFullScreen + " .section";

    /**
     * Init array used for fullpage.js plugin
     * Populate the array with each section data-anchor's attribute
     * @type {Array}
     * @private
     */
    var _anchors = [];

    /**
     * Auto scroll init
     * @type {boolean}
     * @private
     */
    var _autoScrolling = true;

    /**
     * init var for loopTop parameter (FullPage.js)
     * @type {boolean}
     * @private
     */
    var _loopTop = true;

    /**
     * init var for scrollingSpeed parameter (FullPage.js)
     * @type {number}
     * @private
     */
    var _scrollingSpeed = 700;

    /**
     * init array to contain FullPage.js parameters
     * @type {{
     *     loopBottom: boolean,
     *     loopTop: boolean,
     *     paddingBottom: string,
     *     anchors: *,
     *     onLeave:
     *     sliderFullScreenConfig.onLeave
     * }}
     */
    var sliderFullScreenConfig = {};

    /**
     * Mobile Breakpoint (px)
     * @type {number}
     */
    var _mobileBreakpoint = 1185;

    /**
     * Current Wordpress page
     */
    var _wpPage;

    /**
     * Initializes the behavior.
     */
    referencesManager.init = function (page) {
        _wpPage = page;

        if(($(document).height() < 800) || ($(document).height() < 1441)) {
            _autoScrolling = false;
        }

        _initTheSliders();
        _handleEvents();
        _resize();
    };

    /**
     * Handle events
     */
    var _handleEvents = function () {
        $("#content").on('load',function(){
            var _featured = $(_menuItem + '.featured');
            _featured.prev().addClass('sibling');
            _featured.next().addClass('sibling');

            _menuCentered();
        });

        $(window).on("resize", function(){
            _resize();
        });

        $(document).on('click', _bxNextSelector + " a",function(e){
            var _current = $(_menuItem + '.featured');
            var _lineToHighlight = _current.next().not('.bx-clone');

            _sliderNav.goToSlide(_lineToHighlight.index(_menuItem + ':not(.bx-clone)'));
            _lineToHighlight.find("a").click();
        });

        $(document).on('click', _bxPrevSelector + " a",function(e){
            var _current = $(_menuItem + '.featured');
            var _lineToHighlight = _current.prev().not('.bx-clone');

            _sliderNav.goToSlide(_lineToHighlight.index(_menuItem + ':not(.bx-clone)'));
            _lineToHighlight.find("a").click();
        });
    };

    /**
     * This function is useful to change parameters for fullPage.js to init or reload this one
     * @private
     */
    var _updateFullPageOptions = function() {
        if ($.isFunction($.fn.fullpage.destroy)){
            $.fn.fullpage.destroy('all');
        }
        _anchors = [];
        $(fullScreenSections).each(function() {
            _anchors.push($(this).attr('data-anchor'));
        });

        sliderFullScreenConfig = {
            loopBottom:     true,
            loopTop:        _loopTop,
            paddingBottom:  '146px',
            autoScrolling:  _autoScrolling,
            scrollingSpeed: _scrollingSpeed,
            fitToSection:   false,
            scrollBar:      true,
            anchors:        _anchors,
            onLeave:        function(index, indexNext, direction) {
                var _nextSection = $(fullScreenSections).eq((indexNext - 1));
                var _anchorLink =  _nextSection.attr('data-anchor');
                var _anchorSelector = 'a[href="#'+ _anchorLink +'"]';

                if ( $(window).outerWidth() < _mobileBreakpoint && _nextSection.hasClass("current-model") ) {
                    return false;
                }

                // removes all actives and featured classes
                $(_menuItem + _featured).removeClass("featured");
                $(_menuItem).removeClass('sibling');
                $(_paginationFixed + _featured).removeClass("featured");
                $(_paginationFixed).find("a").removeClass("active");

                // adds new featured and active classes
                $(_paginationFixed + ' ' + _anchorSelector).addClass('active').parents(_paginationFixed).addClass("featured");
                var _lineToHighlight = $(_menuItem + ':not(.bx-clone)' + " " + _anchorSelector).parents(_menuItem);

                _lineToHighlight.addClass('featured');
                _lineToHighlight.prev().addClass('sibling');
                _lineToHighlight.next().addClass('sibling');

                //move left menu to featured slide
                var _posInMenu = $(_lineToHighlight).index(_menuItem + ':not(.bx-clone)');
                _sliderNav.goToSlide(_posInMenu);
            }
        };
    };

    /**
     * Recenter the menu when slider is not in infinite loop
     * @private
     */
    var _menuCentered = function() {
        var _marginTop = "";
        var _menuHeight;

        if(_wpPage === "post_type_archive_model_option") {
            _menuHeight = $(_infiniteMenu).outerHeight();
            _marginTop = -((_menuHeight / 2) + 40) + "px";
        } else {
            //_marginTop = "-40px";
            _menuHeight = $(_infiniteMenu).outerHeight();
            _marginTop = -((_menuHeight / 2) + 40) + "px";
        }

        $(".menu-container .bx-viewport").css('margin-top', _marginTop);
    };


    /**
     * Init or reload BxSlider and fullPage.js depending of the screen's width
     * @param page
     * @private
     */
    var _initTheSliders = function(){

        if ($.isFunction($.fn.fullpage.destroy)){
            $.fn.fullpage.destroy('all');
        }

        // Handle BxSlider
        if(_sliderNav !== false){
            _sliderNav.destroySlider();
        }

        if( $(window).outerWidth() < _mobileBreakpoint ) {
            var _mobileSliderConfig = $.extend({}, sliderConfig);
            _mobileSliderConfig.mode = 'horizontal';
            _mobileSliderConfig.minSlides = 3;
            _mobileSliderConfig.maxSlides = 3;
            _mobileSliderConfig.slideWidth = 200;
            _mobileSliderConfig.speed = 200;

            _sliderNav = $(_infiniteMenu).bxSlider(_mobileSliderConfig);

            $(_menuItem).find('a').on('click', function() {
               _handleMobileNav($(this).parents(_menuItem));
            });

        } else {

            // Handle BxSlider
            if(_wpPage === "post_type_archive_model_option"){
                sliderConfig.infiniteLoop = false;
                _menuCentered();
            } else {
                //sliderConfig.infiniteLoop = true;
                sliderConfig.infiniteLoop = false;
                _menuCentered();
            }

            if(_sliderNav !== false){
                _sliderNav.destroySlider();
            }

            _sliderNav = $(_infiniteMenu).bxSlider(sliderConfig);

            // Handle FullPage options
            _loopTop = false;
            _autoScrolling = true;
            _scrollingSpeed = 700;
            if ($('footer').css('position') === 'relative') {
                _autoScrolling = false;
            }
            _updateFullPageOptions();
            $(sliderFullScreen).fullpage(sliderFullScreenConfig);
        }
    };

    /**
     * Handle
     * @param item
     * @private
     */
    var _handleMobileNav = function (item) {
        if($(window).outerWidth() < _mobileBreakpoint){
            $(_menuItem + _featured).removeClass("featured");
            $(_menuItem).removeClass('sibling');

            var _posInMenu = item.index(_menuItem + ":not('.bx-clone')");
            _sliderNav.goToSlide(_posInMenu);

            var _itemsFeaturedHref = $(item).find("a").first().attr("href");
            var _itemsFeatured = $(_menuItem + ' a[href="'+ _itemsFeaturedHref +'"]').parents(_menuItem);
            _itemsFeatured.addClass('featured');
            _itemsFeatured.prev().addClass('sibling');
            _itemsFeatured.next().addClass('sibling');

            $(fullScreenSections + '.current-model > *').stop().animate({'opacity': 0}, function() {
                $(fullScreenSections).removeClass('current-model');
                $(item).find('a').each(function(){
                    var _href = $(this).attr("href").substring(1);
                    var _section = $(fullScreenSections + '[data-anchor="' + _href +'"]');
                    $(_section).find('> *').stop().css('opacity', 0);
                    $(_section).addClass('current-model');
                    $(_section).find('> *').animate({'opacity': 1});
                });
            });
        }
    };

    var _resize = function() {
        if(($(document).height() < 800) || ($(document).height() < 1441)) {
            _autoScrolling = false;
        }

        _initTheSliders();

        if(_wpPage === "post_type_archive_model_option"){
            _menuCentered();
        } else {
            _menuCentered();
        }
    };
})(
    window.app.referencesManager = window.app.referencesManager || {},
    jQuery
);
